export const Toggles = {
  TOGGLE_V3_ACCESS: 'TOGGLE_V3_ACCESS',
  TOGGLE_MANAGER_VIEW: 'TOGGLE_MANAGER_VIEW',
  TOGGLE_NV_SYNC: 'TOGGLE_NV_SYNC',
  TOGGLE_NETWORK_DASHBOARD: 'TOGGLE_NETWORK_DASHBOARD',
  TOGGLE_STUD_LEVEL_NET_DASH: 'TOGGLE_STUD_LEVEL_NET_DASH',
  TOGGLE_NYCT_MVP: 'TOGGLE_NYCT_MVP',
  TOGGLE_COLLEGE_LIST_CSV_UPLOAD: 'TOGGLE_COLLEGE_LIST_CSV_UPLOAD',
  TOGGLE_REMOTE_INTERACTION: 'TOGGLE_REMOTE_INTERACTION',
  TOGGLE_GOOGLE_CLASSROOM: 'TOGGLE_GOOGLE_CLASSROOM',
  TOGGLE_GRADEBOOK: 'TOGGLE_GRADEBOOK',
};
